import { Requester } from './Requester';
import { ISurveyFull } from '../types';

export const SubmitSurvey = async ({ surveyId }: { surveyId?: string }): Promise<any> => {
    try {
        const response = await Requester<any | null>({
            path: `surveys/${surveyId}/submit`,
            method: 'POST'
        });

        return response;
        // return response && Object.hasOwn(response, '_id') ? (response as any) : null;
    } catch (e) {
        console.error('Submit survey request failed');
        return Promise.reject(e);
    }
};
